var VuexModule = /** @class */ (function () {
    function VuexModule(options) {
        this.__options = options;
    }
    VuexModule.prototype.$watch = function (fn, callback, options) {
        return function () { };
    };
    return VuexModule;
}());
export { VuexModule };
